import constants from '@/utils/constants';

function replaceContentPlaceholder(content, ...args) {
  let finalText = content || '';
  for (let i = 0; i < args.length; i += 1) {
    finalText = finalText.replace(`%${i + 1}$s`, args[i]);
  }
  return finalText;
}

function replaceContentGlobalConstants(content) {
  let finalText = content || '';
  finalText = finalText.replaceAll(constants.OWNER_TAG, constants.OWNER);
  finalText = finalText.replaceAll(constants.CONTACT_TAG, constants.CONTACT);
  finalText = finalText.replaceAll(constants.BRAND_TAG, constants.BRAND);
  return finalText;
}

async function mapViewNameToJsonContent(viewName) {
  let json = {};
  switch (viewName) {
    case 'privacyPolicy':
      json = await import('../store/content/texts/privacy-policy.json');
      break;
    case 'termsConditions':
      json = await import('../store/content/texts/terms-conditions.json');
      break;
    case 'header':
      json = await import('../store/content/texts/header.json');
      break;
    case 'footer':
      json = await import('../store/content/texts/footer.json');
      break;
    case 'home':
      json = await import('../store/content/texts/home.json');
      break;
    case 'cookiePolicy':
      json = await import('../store/content/texts/cookie-policy.json');
      break;
    default:
      break;
  }
  return json.text;
}

export {
  replaceContentPlaceholder,
  replaceContentGlobalConstants,
  mapViewNameToJsonContent,
};
